module.exports = __webpack_public_path__ + "img/0Q3A4226_L_Wood.5c198ca0.jpg";